import { MODALS } from 'common/domain/constants';
import formatters from 'common/utils/periods.formatters';

class ModalCalendarGridController {

  constructor($window, modalCalendarGridService, vacationUserDataService) {
    'ngInject';
    this.window = $window;
    this.modalCalendarGridService = modalCalendarGridService;
    this.UserDataService = vacationUserDataService;
    this.loaded = false;
    this.dateToday = new Date();
  }

  $onInit(){
    const userId = this.userInceptionId || this.userId;
    const managerId = this.UserDataService._employee.userId;
    this.scheduleData = {};
    this.modalCalendarGridService.getRequestModalPeriods(userId, this.isInception, managerId).then((response) => {
      this.scheduleData.vacationPeriods = response.data;
      this.scheduleData.absencePeriods = [];
      this.scheduleData.periodInDays = formatters.formatPeriodInDays(this.scheduleData.vacationPeriods);
      this.loaded = true;
    });
  }

  $postLink() {
    let modalId = MODALS.CALENDAR_GRID.slice(1);
    this.modal = document.getElementById(modalId);
    this.body = document.getElementsByTagName('body')[0];
    this.initPrintEvents();

    $(MODALS.CALENDAR_GRID).on('hidden.bs.modal', () => this.onDismiss());
  }

  initPrintEvents() {
    const beforePrint = () => {
      if (this.visible(this.modal)) {
        this.body.classList.add('printing-calendar-grid');
      }
    };

    const afterPrint = () => {
      if (this.visible(this.modal)) {
        this.body.classList.remove('printing-calendar-grid');
      }
    };

    if (this.window.matchMedia) {
      const mediaQueryList = this.window.matchMedia('print');
      mediaQueryList.addListener((mql) => {
        if (mql.matches) {
          beforePrint();
        } else {
          afterPrint();
        }
      });
    }

    this.window.onbeforeprint = beforePrint;
    this.window.onafterprint = afterPrint;
  }

  print() {
    this.window.print();
  }

  visible (elem) {
    return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
  }
}

export default ModalCalendarGridController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalCalendarGrid/modalCalendarGrid.controller.js